// frontend/src/lib/accountInUse.js
// PACK-UI §2.7 — единый гард удаления `deleteExtraAccount` отказывает с
// 409 { error:'account_in_use', details:{ accountId, blockedBy } }, а когда
// Timescale не опросить — с 503 metrics_unavailable. Отказ приходит с ОБОИХ
// путей удаления (сохранение экстр в карточке — crud.js PATCH, и отцепление
// в редакторе пачек — packs.js DELETE /:id/accounts/:accountId), поэтому
// русская копия живёт в одном месте.
// NB: api/client.js расплющивает ошибку — у отклонённого значения есть `err.data`
// и НЕТ `err.response` (прецедент: lib/contractDeleteError.js).

import { HANDLE_LOCK_HINT } from './accountHandleLock.mjs';

// Метки = таблицы-ссылки из backend/src/services/socialAccounts/index.js:287-294
// плюс `timescale_posts` (посты в метриках) и `primary` (RT-CL-04: основной аккаунт
// блогера — не экстра, гард отказывает до проверки ссылок).
const BLOCKED_BY_LABEL = {
  TestRoundCheckpoint: 'чекпоинт раунда',
  SocialMetricSnapshot: 'снапшоты метрик',
  LeadMonitoringPost: 'посты мониторинга',
  invoices: 'инвойс',
  CollaborationBonus: 'бонус за коллаборацию',
  VideoBonus: 'бонус за видео',
  timescale_posts: 'посты в метриках',
  primary: 'основной аккаунт блогера',
};

export const METRICS_UNAVAILABLE_MESSAGE = 'Метрики недоступны — проверить аккаунт нельзя, попробуй позже.';

/**
 * RU-текст отказа удаления аккаунта, или null — если ошибка не из этого контракта.
 * @param {object} err — отклонённое значение api/client.js (`err.data` = тело ответа).
 * @returns {string|null}
 */
export function accountRemovalErrorMessage (err) {
  const code = err?.data?.error;
  if (code === 'metrics_unavailable') return METRICS_UNAVAILABLE_MESSAGE;
  if (code === 'account_handle_locked') return HANDLE_LOCK_HINT;
  if (code !== 'account_in_use') return null;
  const reasons = (err?.data?.details?.blockedBy ?? []).map((k) => BLOCKED_BY_LABEL[k] ?? k);
  return reasons.length > 0
    ? `Аккаунт нельзя убрать — за ним стоят: ${reasons.join(', ')}.`
    : 'Аккаунт нельзя убрать — за ним стоят данные парсинга.';
}
